import { render, staticRenderFns } from "./SwipeMenu.vue.js?vue&type=template&id=0bff21a8&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SwipeMenu.vue?vue&type=template&id=0bff21a8&scoped=true"
import script from "./SwipeMenu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SwipeMenu.vue?vue&type=script&lang=js"
export * from "./SwipeMenu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SwipeMenu.vue?vue&type=script&lang=js"
import style0 from "./SwipeMenu.vue.scss?vue&type=style&index=0&id=0bff21a8&prod&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SwipeMenu.vue?vue&type=style&index=0&id=0bff21a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff21a8",
  null
  
)

export default component.exports